export const EMBEDDED_WEBVIEW_COOKIE = "EmbeddedWebview";
export const ORIGIN = "origin";
export const APP_VERSION = "AppVersion";
